// Put your applicaiton javascript here

const stopAllYouTubeVideos = () => { 
    var iframes = document.querySelectorAll('iframe.yt-embed');
    Array.prototype.forEach.call(iframes, iframe => { 
         iframe.contentWindow.postMessage(JSON.stringify({ 
        event: 'command', 
        func: 'stopVideo' 
        }), '*');
   });
}

document.querySelectorAll('.yt-modal').forEach(item => {
    item.addEventListener('click', () => {
        stopAllYouTubeVideos()
    })
})

  // Function to set aria-label attribute to close button
  function setAriaLabelToClose() {
      var closeButton = document.querySelector(".gl-d-close-btn");
      if (closeButton) {
          closeButton.setAttribute("aria-label", "close");
      }
  }
  var observer = new MutationObserver(function(mutationsList, observer) {
      for(var mutation of mutationsList) {
          if (mutation.type === 'childList') {
              var popup = document.querySelector('#glFilter-search-popup');
              if (popup) {
                  setAriaLabelToClose();
                  search_product();
                  searchLive();
                  redundant();
                  //live();
                  // closeFocus();
                  closePop();
                  //createList()
                  break;
              }
          }
      }
  });
  observer.observe(document.body, { childList: true, subtree: true });

 

/**/
/*
window.addEventListener('load', function() {
    if (window.location.href === 'https://shopbellavita.com/') {
        var carouselContainers = document.querySelectorAll('.slick-track');
        var firstCarouselContainer = carouselContainers[0];

        if (firstCarouselContainer) {
            var slides = firstCarouselContainer.querySelectorAll('.item');
            firstCarouselContainer.removeAttribute('role');
            slides.forEach(function(slide, index) {
                if (index < 3) {
                    slide.setAttribute('role', 'group');
                    var ariaLabel = "slide " + (index + 1) + " of " + slides.length;
                    slide.setAttribute('aria-label', ariaLabel);
                    slide.removeAttribute('aria-describedby');
                }
            });
        }

        var nextButton = document.querySelector('.slick-next');
        var prevButton = document.querySelector('.slick-prev');
        if (nextButton) {
            nextButton.setAttribute('aria-label', 'Next Slide');
        }

        if (prevButton) {
            prevButton.setAttribute('aria-label', 'Previous Slide');
        }
        var firstSection = document.querySelector('section');
        if (firstSection) {
            var sectionAriaLabel = "Featured collections carousel";
            firstSection.setAttribute('aria-label', sectionAriaLabel);
        }
    }
});
*/

//for search input field
function search_product() {
  var searchin = document.querySelector('.gl-d-searchbox-icon svg')
  if (searchin) {
  searchin.setAttribute('aria-label','Search for products, gifts, ideas')
  searchin.setAttribute("role", "img");
  searchin.setAttribute("focusable", "false");
  } };

//To make images redundant
 function redundant() {
  const red = document.querySelectorAll('.spf-image-ratio');
  red.forEach(element => {
    element.setAttribute('aria-hidden', 'true');
    element.setAttribute('tabindex', '-1');
  });
}

//Carousel update
function carouselUpdate(){
  var carouselContainers = document.querySelectorAll('.slick-track');
  var firstCarouselContainer = carouselContainers[0];
  
  if (firstCarouselContainer) {
    var slides = firstCarouselContainer.querySelectorAll('.slick-slide');
    console.log(slides.length);
    firstCarouselContainer.removeAttribute('role', 'group');
    slides.forEach(function(slide, index) {
      if (index) {
        //console.log(slide);
        slide.setAttribute('role', 'group');
        var ariaLabel = "slide " + (index) + " of " + (slides.length -1);
        slide.setAttribute('aria-label', ariaLabel);
        slide.removeAttribute('aria-describedby');
        }
      });
    }
}

document.addEventListener('DOMContentLoaded', function() { 
   if (document.body.id === 'bella-vita-gifts-and-interior-decor-for-the-beautiful-life') {
     carouselUpdate();
   }
        var nextButton = document.querySelector('.slick-next');
        var prevButton = document.querySelector('.slick-prev');
        if (nextButton) {
            nextButton.setAttribute('aria-label', 'Next Slide');
        }

        if (prevButton) {
            prevButton.setAttribute('aria-label', 'Previous Slide');
        }
        var firstSection = document.querySelector('section');
        if (firstSection) {
            var sectionAriaLabel = "Featured collections carousel";
            firstSection.setAttribute('aria-label', sectionAriaLabel);
        }
      // var ariaLiveRegion = document.getElementById('aria-live-region');
      
      // // Function to update aria-live region with the name of the current active slide
      // function updateAriaLiveRegion() {
      //     var activeSlide = document.querySelector('.slick-slide.slick-current');
      //     if (activeSlide) {
      //         var slideName = activeSlide.querySelector('.slide-image img').alt;
      //         ariaLiveRegion.textContent = slideName;
      //     }
      // }
    
    // MutationObserver to detect changes in the DOM
    var observer = new MutationObserver(function(mutationsList, observer) {
        for(var mutation of mutationsList) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
              //updateAriaLiveRegion();
              carouselUpdate();
            }
        }
    });
    
    // Observe changes to the class attribute of slick-slide elements
    observer.observe(document.querySelector('.slick-track'), { attributes: true, subtree: true });
});

//Providing focus to close button in search dialog
// function closeFocus() {
//   var closeButtons = document.querySelector('.gl-d-close-btn');
//   closeButtons.addEventListener('focus', () => {
//     closeButtons.closeFocus.classList.add('focused');
//   });
//  }
/**/

//Function to hide the search popup
// function hideSearchPopup() {
//     var searchPopup = document.getElementById('glFilter-search-popup');
//     if (searchPopup) {
//         searchPopup.setAttribute('hidden', 'true');
//     }
// }

// var observer2 = new MutationObserver(function(mutationsList, observer2) {
//     for(var mutation of mutationsList) {
//         if (mutation.type === 'childList') {
//             var addedNodes = mutation.addedNodes;
//             for (var node of addedNodes) {
//                 if (node.id === 'glFilter-search-popup') {
//                     hideSearchPopup();
//                     setTimeout(function() {
//                       focusSearchInput();
//                     }, 100);
//                     break;
//                 }
//             }
//         }
//     }
// });

// observer2.observe(document.body, { childList: true, subtree: true });

// function focusSearchInput() {
//     var searchInput;
//     if (window.innerWidth >= 1200) {
//         searchInput = document.querySelector('.header-pc .header-search__input');
//         console.log('Yesss',searchInput);
//     } else {
//         searchInput = document.querySelector('.header-search__input:first-of-type');
//         console.log('Noooo',searchInput);
//     }
//     if (searchInput) {
//         searchInput.focus();
//     }
// }

//Live region for searchpopup results
function searchLive() {
  var errorLive = document.querySelector('.gl-fullscreen-suggestions');
  var resultsLive = document.querySelector('.gl-fullscreen-initial-content');
  errorLive.setAttribute('aria-live', 'polite');
  resultsLive.setAttribute('aria-live', 'polite');
}

//set focus to the search field on closing the search popup
function closePop() {
  var inputS = document.querySelector('.header-pc .search-form input[type="search"]');
  var searchPop = document.getElementById('glFilter-search-popup');
  var searchClose = document.querySelector('.gl-d-close-btn');
  searchPop.addEventListener('keydown', function(e) {
    if(e.key === 'Escape'){
        const focusedE = document.activeElement;
        inputS.focus();
    }
});
  searchClose.addEventListener('click', function(e){
    inputS.focus();
  });
}

